import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { black } from '../styles/theme';

const fill = black;

const Svg = styled.svg`
  width: ${props => props.width || '50%'};
`;

class Logo extends PureComponent {
  render() {
    const { width, logoRef, ...rest } = this.props;

    return (
      <Svg
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="205.009 1296.804 248.991 58.196"
        ref={logoRef}
        {...rest}
      >
        <g id="Group_31" data-name="Group 31" transform="translate(0 1220)">
          <g id="fmt__logo-01" transform="translate(205.009 76.804)">
            <path
              id="Path_1"
              data-name="Path 1"
              style={{ fill: fill }}
              d="M39.186,1c.361.025.722.05,1.088.071,1.138.067,2.272.147,3.406.286a23.038,23.038,0,0,1,5.493,1.419,27.321,27.321,0,0,1,7.483,4.388,28.4,28.4,0,0,1,3.9,4.01,20.3,20.3,0,0,1,2.276,3.393,10.771,10.771,0,0,1,.911,2.318.151.151,0,0,1-.025.155,11.075,11.075,0,0,0-2.385-3.448,23.241,23.241,0,0,1,2.973,6.4.378.378,0,0,1-.176-.231A42.865,42.865,0,0,0,60.8,14.006a20.845,20.845,0,0,0-3.368-3.9,10.381,10.381,0,0,0-1.3-.957.424.424,0,0,0-.126-.055,23.781,23.781,0,0,1,7.66,11.141.625.625,0,0,1-.21-.29,32.879,32.879,0,0,0-2.683-4.082,31.242,31.242,0,0,0-7.5-7.177,23.453,23.453,0,0,0-6.837-3.141,34.353,34.353,0,0,0-4.951-1,28.408,28.408,0,0,0-3.162-.2A24.463,24.463,0,0,0,22.312,9.957a28.078,28.078,0,0,0-4.271,4.321,21.39,21.39,0,0,0-3.175,5.556A25.152,25.152,0,0,0,13.405,26a25.7,25.7,0,0,0-.046,4.922,30.654,30.654,0,0,0,1.18,6.425,19.083,19.083,0,0,0,1.755,4.212,16.578,16.578,0,0,0,1.957,2.591,36.194,36.194,0,0,0,6.224,5.518c.819.58,1.709,1.046,2.528,1.617a9.51,9.51,0,0,0,1.621,1.041c.017.008.025.029.021.067a20.611,20.611,0,0,1-7.483-4.149,4.513,4.513,0,0,0,.722.8,19.546,19.546,0,0,0,5.308,3.414,29.175,29.175,0,0,0,4.871,1.751,18.612,18.612,0,0,0,3.6.533,27.384,27.384,0,0,0,8.945-1.02,21.619,21.619,0,0,0,6.421-2.843,9.111,9.111,0,0,0,2.112-1.9.64.64,0,0,0,.151-.252A16.163,16.163,0,0,1,42.365,52.4c.042-.118.126-.1.185-.118a27.567,27.567,0,0,0,4.783-1.629,16.411,16.411,0,0,0,5.035-3.288A37.974,37.974,0,0,0,54.892,44.5a28.087,28.087,0,0,0,2.654-3.821c.21-.37.391-.76.584-1.138.029-.059.029-.139.13-.168a4.4,4.4,0,0,1-.168,1.222c-.1.395-.235.773-.365,1.159a4.858,4.858,0,0,0,.735-1.016c.214-.37.361-.768.542-1.167.1.063.08.155.08.231a4.732,4.732,0,0,1-.5,1.894,18.84,18.84,0,0,1-2.226,3.62,1.4,1.4,0,0,0-.139.21,9.311,9.311,0,0,0,1.844-1.747,2.682,2.682,0,0,1-.21,1.041,8.07,8.07,0,0,1-.462,1.037c1.243-1.1,2.788-5.43,2.528-7.026a2.653,2.653,0,0,1-.277.26c-.181.109-.286.071-.336-.139a1.112,1.112,0,0,1-.025-.29c.008-.559.038-1.121.025-1.68a10.308,10.308,0,0,0-.2-2.062c-.1-.466-.315-.9-.454-1.352a2.017,2.017,0,0,1-.067-1.277A2.691,2.691,0,0,1,60.2,30.505a5.006,5.006,0,0,1,6.946,4.187c0,.046.021.1.029.143v1.638a1.249,1.249,0,0,0-.042.353,19,19,0,0,1-1.772,6.009,27.662,27.662,0,0,1-2.923,4.745,32.683,32.683,0,0,1-4.993,5.312,26.478,26.478,0,0,1-5.241,3.5,25.155,25.155,0,0,1-4.5,1.713,28.176,28.176,0,0,1-5.816,1.016c-.294.021-.584.046-.873.071h-2.31c-.067-.008-.139-.025-.206-.029-.726-.021-1.453-.092-2.175-.181a27.976,27.976,0,0,1-7.185-1.877c-1.562-.643-3.057-1.424-4.544-2.213a49.087,49.087,0,0,1-5.455-3.3A11.288,11.288,0,0,1,17.4,50.142a.43.43,0,0,1-.164-.269c.227.147.42.277.617.4a2.708,2.708,0,0,0,.634.315,22.545,22.545,0,0,1-2.923-2.738,14.483,14.483,0,0,1-2.255-3.3.392.392,0,0,1,.307.16c.42.386.789.81,1.172,1.23a14.01,14.01,0,0,0,3.25,2.759c.168.1.344.176.563.294-.441-.454-.848-.848-1.23-1.264A31.367,31.367,0,0,1,13.292,42.3a20.722,20.722,0,0,1-2.461-6.064c-.252-1.146-.395-2.314-.554-3.481a38.791,38.791,0,0,1-.349-3.884,15.611,15.611,0,0,1,.307-3.507c.059-.307.1-.613.155-.92.017,0,.038,0,.055,0,0,1.188-.059,2.373.046,3.557a19.622,19.622,0,0,1,.16-2.049,31.966,31.966,0,0,1,1.2-5.577,21.887,21.887,0,0,1,4.141-7.786c.2-.235.412-.466.63-.714-.038,0-.055,0-.063.008-.042.034-.088.071-.13.109a14.544,14.544,0,0,0-2.4,2.826,28.388,28.388,0,0,0-3.465,7.681c-.1.315-.189.634-.281.953-.025-.008-.05-.013-.08-.021a13.515,13.515,0,0,1,1.646-6.207.179.179,0,0,0-.055.059,17.786,17.786,0,0,0-1.327,2.872,22.067,22.067,0,0,0-1.222,7.832c0,.122.067.307-.118.332-.164.017-.176-.164-.223-.286a.883.883,0,0,1-.025-.1A6.723,6.723,0,0,1,8.74,26.52a21.857,21.857,0,0,1,.151-3.435A22.463,22.463,0,0,1,10.84,16.32c.189-.4.4-.794.6-1.193-.323.3-.533.693-.827,1.025a.494.494,0,0,1,.038-.181,13.338,13.338,0,0,1,.643-1.411A22.2,22.2,0,0,1,17.47,7.291a27.08,27.08,0,0,1,5.4-3.2,33.666,33.666,0,0,1,6.719-2.3,31.106,31.106,0,0,1,4.976-.722c.294-.017.584-.046.878-.067ZM37.447,58c0-.017,0-.034,0-.05-1.193-.235-2.385-.479-3.582-.706a20.475,20.475,0,0,1-4.019-1.1,9.377,9.377,0,0,1-2.129-1.167c-.063-.05-.16-.08-.185-.218,1.26.391,2.486.773,3.716,1.159C27.835,54.333,24.4,52.8,21.015,51.1c0,.1.067.113.109.143a42.047,42.047,0,0,0,8.882,5.3,16.488,16.488,0,0,0,2.5.907,17.483,17.483,0,0,0,2.675.391C35.94,57.9,36.7,57.944,37.447,58ZM18.986,46.543a1.385,1.385,0,0,0,.672.727A1.21,1.21,0,0,0,18.986,46.543Z"
              transform="translate(-8.4 -1)"
            />
            <path
              id="Path_2"
              data-name="Path 2"
              style={{ fill: fill }}
              d="M.9,895.312c.206-.332.365-.332.58,0a2.269,2.269,0,0,1,.252.529,24.544,24.544,0,0,0,1.13,2.545c.143.3.277.609.412.916a1.67,1.67,0,0,1,.1.319c.017.072.059.16-.025.21s-.134-.021-.189-.059a2.554,2.554,0,0,1-.4-.395c-.428-.5-.8-1.041-1.209-1.554a2.9,2.9,0,0,1-.567-1.088c-.025-.109-.059-.214-.088-.323C.9,896.038.9,895.677.9,895.312Z"
              transform="translate(-0.9 -857.517)"
            />
            <path
              id="Path_3"
              data-name="Path 3"
              style={{ fill: fill }}
              d="M97.3,1087.565a2.028,2.028,0,0,1-.659-.055,23.2,23.2,0,0,1-7.714-2.591A27.67,27.67,0,0,1,83.393,1081a33.081,33.081,0,0,1-3.649-3.788,8.357,8.357,0,0,1-1.05-1.663c-.055-.122-.172-.286-.042-.386s.248.071.349.151a37.556,37.556,0,0,1,2.952,2.708,29.794,29.794,0,0,0,6.026,4.691c2.23,1.318,4.472,2.6,6.824,3.7.685.319,1.386.6,2.079.9A1.165,1.165,0,0,1,97.3,1087.565Z"
              transform="translate(-75.33 -1030.02)"
            />
            <path
              id="Path_4"
              data-name="Path 4"
              style={{ fill: fill }}
              d="M80.605,1041.727c-.008.231-.193.349-.353.231a2.028,2.028,0,0,1-.668-.844.153.153,0,0,1,.021-.177.139.139,0,0,1,.176-.012,2.135,2.135,0,0,1,.781.68A.246.246,0,0,1,80.605,1041.727Z"
              transform="translate(-76.263 -997.23)"
            />
            <path
              id="Path_5"
              data-name="Path 5"
              style={{ fill: fill }}
              d="M77.093,1014.1a.477.477,0,0,1,.42.4.329.329,0,0,1-.294.365.477.477,0,0,1-.42-.47A.292.292,0,0,1,77.093,1014.1Z"
              transform="translate(-73.611 -971.555)"
            />
            <path
              id="Path_6"
              data-name="Path 6"
              style={{ fill: fill }}
              d="M391.7,1245.3c0,.08-.05.151-.109.113-.231-.147-.546-.147-.722-.391-.076-.1-.2-.218-.109-.348s.235-.042.349,0A.991.991,0,0,1,391.7,1245.3Z"
              transform="translate(-374.355 -1192.385)"
            />
          </g>
          <text
            id="Forward_Motion_Therapy"
            data-name="Forward Motion Therapy"
            style={{
              fill: fill,
              fontSize: '24px',
              fontFamily: 'Raleway Bold, Raleway',
              fontWeight: 700
            }}
            transform="translate(274 100)"
          >
            <tspan x="0" y="0">
              Forward Motion
            </tspan>
            <tspan x="0" y="29">
              Therapy
            </tspan>
          </text>
        </g>
      </Svg>
    );
  }
}

Logo.propTypes = {
  width: PropTypes.string
};

export default Logo;
